import { Audience_Purchase_Time_Window, Event_Targeting_Condition_Operator } from '@occc/graphql';

export const rollingWindowOptions = [
  { label: 'Not Defined', value: undefined },
  { label: '7 days', value: Audience_Purchase_Time_Window.Last_7Days },
  { label: '14 days', value: Audience_Purchase_Time_Window.Last_14Days },
  { label: '30 days', value: Audience_Purchase_Time_Window.Last_30Days },
  { label: '60 days', value: Audience_Purchase_Time_Window.Last_60Days },
  { label: '90 days', value: Audience_Purchase_Time_Window.Last_90Days },
];

export const eventPurchaseConditionOperatorOptions = [
  { label: 'Exactly', value: Event_Targeting_Condition_Operator.IsEqualTo },
  { label: 'More than', value: Event_Targeting_Condition_Operator.IsGreaterThan },
  { label: 'More or equal to', value: Event_Targeting_Condition_Operator.IsGreaterThanOrEqualTo },
  { label: 'Less than', value: Event_Targeting_Condition_Operator.IsLessThan },
  { label: 'Less or equal to', value: Event_Targeting_Condition_Operator.IsLessThanOrEqualTo },
];

export const eventTargetingConditionOperatorToLabelMap: Record<
  Event_Targeting_Condition_Operator,
  string
> = {
  [Event_Targeting_Condition_Operator.IsEqualTo]: 'Exactly',
  [Event_Targeting_Condition_Operator.IsGreaterThan]: 'More than',
  [Event_Targeting_Condition_Operator.IsGreaterThanOrEqualTo]: 'More or equal to',
  [Event_Targeting_Condition_Operator.IsLessThan]: 'Less than',
  [Event_Targeting_Condition_Operator.IsLessThanOrEqualTo]: 'Less or equal to',
};
